import SearchCards from '../utils/SearchCards';
import InternshipCard from './InternshipCard';
import InternshipsAPI from '../Apis/InternshipsAPI';

function InternshipsSearchPage() {
    return (
        <>
            <SearchCards selected='Work From Home'
                card={InternshipCard}
                api={InternshipsAPI.fetchInternships}
            />
        </>
    );
}

export default InternshipsSearchPage;